export const SHOP_THE_LOOK_GET_REQUEST = 'SHOP_THE_LOOK_GET_REQUEST';
export const SHOP_THE_LOOK_GET_SUCCESS = 'SHOP_THE_LOOK_GET_SUCCESS';
export const SHOP_THE_LOOK_GET_ERROR = 'SHOP_THE_LOOK_GET_ERROR';
export const INITIATE_LOADING = 'INITIATE_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const UPDATE_LAST_SELECTED_COLOR = 'UPDATE_LAST_SELECTED_COLOR';
